  <script>
  export let tipoUsuario="";
  export let espacamentoSuperior="";
  export let espacamentoInferior="";
  export let sombra1=0;
  export let sombra2=0; 
  export let sombra3=0;
  export let sombra4=0;
  export let corSombra=0;
  export let apenasUmEspacamento=false;
  export let ExibirFonte=false; 
  export let tamanhoLetra=35;
 $:tipoUsuario=tipoUsuario.toUpperCase(); 
  export let fontes=[
"",
"'Anton', sans-serif",
"'Dancing Script', cursive",
"'Dosis', sans-serif",
"'Lobster', cursive",
"'Montserrat', sans-serif",
"'Pacifico', cursive",
"'Roboto', sans-serif",
"'Roboto Slab', serif",
"'Pangolin', cursive",
"'Notable', sans-serif"


    ]
    export let fonte="";
    export let numFonte=0;


  let expande=false;
  let outline="";
  $:if(expande){
    outline="btn-outline-primary";


  } else{
      outline="btn-primary";
  }
  $:fonte=fontes[numFonte];
  </script>
 
  <div class="col-12 text-center">
  
        <button class="mb-5 btn {outline}" on:click|preventDefault={()=>expande=!expande}>Configurações avançadas</button>
        
                <div class="border">
{#if expande}
        {#if tipoUsuario=="PRO" || tipoUsuario=="MASTER"}
           <h5>Apenas PRO</h5><p>
		   px=pixel
		   </p>  
			<div class="row">
                {#if !apenasUmEspacamento}
				<div class="col-lg-6 col-12">
                        
						<label class="mt-2" for="espacamentoSuperior">Espaçamento superior</label>
					
						<input class="form-control" type="range" id="espacamentoSuperior"  max="900" bind:value={espacamentoSuperior} />
						<input type="text" class="sm mt-2"  bind:value={espacamentoSuperior}/>px
					
						<p>
			 	</div>
				<div class="col-lg-6 col-12">
						<label class="mt-2" for="espacamentoInferior">Espaçamento inferior</label>
					
						<input class="form-control" type="range" id="espacamentoInferior"  max="900" bind:value={espacamentoInferior} />
						<input type="text" class="sm mt-2"  bind:value={espacamentoInferior}/>px
			    </div>
                {:else}
                <div class="col-12">
                        
						<label class="mt-2" for="espacamentoSuperior">Espaçamento</label>
					
						<input class="form-control" type="range" id="espacamentoSuperior"  max="900" bind:value={espacamentoSuperior} />
						<input type="text" class="sm mt-2"  bind:value={espacamentoSuperior}/>px
					
				</div>
                {/if}
            </div>
           
           {#if ExibirFonte}
           <div class="row">
			<div class="col-6">
                <h5 class="mt-2">Selecione a fonte</h5>
                <select class="form-control" bind:value={numFonte}>
     
                <option value=0  >Padrão</option>
                <option value=1 style="font-family: 'Anton', sans-serif">Anton</option>
                <option value=2 style="font-family:'Dancing Script', cursive">Dancing Script</option>
                <option value=3 style="font-family:'Dosis', sans-serif">Dosis</option>
                <option value=4 style="font-family:'Lobster', cursive">Lobster</option>
                <option value=5 style="font-family:'Montserrat', sans-serif">Montserrat</option>
                <option value=6 style="font-family: 'Pacifico', cursive">Pacifico</option>
                <option value=7 style="font-family: 'Roboto', sans-serif">Roboto</option>
                <option value=8 style="font-family: 'Roboto Slab', serif">Roboto Slab</option>
                <option value=9 style="font-family: 'Notable', sans-serif">Notable</option>
                <option value=10 style="font-family: 'Pangolin', cursive">Pangolin</option>
                
                
                </select>
            </div>
            <div class="col-6">
                <label class="mt-2" for="tamanhoLetra">Tamanho da Letra</label>
					
						<input class="form-control" type="range" id="tamanhoLetra"  max="900" bind:value={tamanhoLetra} />
						<input type="text" class="sm mt-2"  bind:value={tamanhoLetra}/>px
					
                
               
            </div>
            </div>
            {/if}
			<div class="col-12">
			<h5 class="mt-2" for="sombra1">Sombreamento da área de descrição    </h5> 
			<p></p>
			
			
			
			</div>
		 
         <div class="col-12">
			<div class="row  text-center">
            
            
                <div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x (deslocamento x)</label>
					<input class="form-control" type="range" id="sombra1"   min="-50" step="0.01" max="500" bind:value={sombra1} />
					<input type="text" class="sm mt-2"  bind:value={sombra1}/>px
			
				
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Offset y (deslocamento y)</label>
					<input class="form-control" type="range" id="sombra2"  min="-50"  step="0.01" max="500" bind:value={sombra2} />
					<input type="text" class="sm mt-2"  bind:value={sombra2}/>px
			
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Blur<br> (borrão)</label>
					<input class="form-control" type="range" id="sombra3"  step="0.01" max="500" bind:value={sombra3} />
					<input type="text" class="sm mt-2"  bind:value={sombra3}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Spread (propagação)</label>
					<input class="form-control" type="range" id="sombra4" step="0.01" max="500" bind:value={sombra4} />
				<input type="text" class="sm mt-2"  bind:value={sombra4}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" type="color" id="corSombra"    bind:value={corSombra} />		
				</div>
            
            </div>
				
		
			</div>
			{:else}
         <h5>Apenas PRO</h5>  
            <div class="row">
               {#if !apenasUmEspacamento}
				<div class="col-lg-6 col-12">
                        
						<label class="mt-2" for="espacamentoSuperior">Espaçamento superior</label>
					
						<input class="form-control" disabled type="range" id="espacamentoSuperior"  max="900" bind:value={espacamentoSuperior} />
						<input type="text" disabled class="sm mt-2"  bind:value={espacamentoSuperior}/>px
					
						<p>
			 	</div>
				<div class="col-lg-6 col-12">
						<label class="mt-2" for="espacamentoInferior">Espaçamento inferior</label>
					
						<input class="form-control" disabled type="range" id="espacamentoInferior"  max="900" bind:value={espacamentoInferior} />
						<input type="text" disabled class="sm mt-2"  bind:value={espacamentoInferior}/>px
			    </div>
                {:else}
                <div class="col-12">
                        
						<label class="mt-2" for="espacamentoSuperior">Espaçamento</label>
					
						<input class="form-control" disabled type="range" id="espacamentoSuperior"  max="900" bind:value={espacamentoSuperior} />
						<input type="text" class="sm mt-2" disabled bind:value={espacamentoSuperior}/>px
					
				</div>
                {/if}
                        <div class="col-12">
                        <h5 class="mt-2" for="sombra1">Sombreamento da área de descrição    </h5> 
                        <p></p>
			
			{#if ExibirFonte} 
            <div class="row">
			<div class="col-6">
                <h5>Selecione a fonte</h5>
                <select class="form-control" disabled bind:value={numFonte}>
     
                <option value=0  >Padrão</option>
                <option value=1 style="font-family: 'Anton', sans-serif">Anton</option>
                <option value=2 style="font-family:'Dancing Script', cursive">Dancing Script</option>
                <option value=3 style="font-family:'Dosis', sans-serif">Dosis</option>
                <option value=4 style="font-family:'Lobster', cursive">Lobster</option>
                <option value=5 style="font-family:'Montserrat', sans-serif">Montserrat</option>
                <option value=6 style="font-family: 'Pacifico', cursive">Pacifico</option>
                <option value=7 style="font-family: 'Roboto', sans-serif">Roboto</option>
                <option value=8 style="font-family: 'Roboto Slab', serif">Roboto Slab</option>
                
                
                </select>
            </div>
             <div class="col-6">
                <label class="mt-2" for="tamanhoLetra">Tamanho da Letra</label>
					
						<input class="form-control" disabled type="range" id="tamanhoLetra"  max="900" bind:value={tamanhoLetra} />
						<input type="text" class="sm mt-2" disabled  bind:value={tamanhoLetra}/>px
					
                
               
            </div>
            </div>
             {/if}
			</div>
           
		 </div>
			<div class="row col-12 text-center">
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x</label>
					<input class="form-control" type="range" disabled id="sombra1"   min="-50" step="0.01" max="500" bind:value={sombra1} />
					<input type="text" disabled class="sm mt-2"  bind:value={sombra1}/>px
			
				
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Offset y</label>
					<input class="form-control" type="range" disabled id="sombra2"  min="-50"  step="0.01" max="500" bind:value={sombra2} />
					<input type="text" class="sm mt-2" disabled  bind:value={sombra2}/>px
			
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Blur</label>
					<input class="form-control" type="range" disabled id="sombra3"  step="0.01" max="500" bind:value={sombra3} />
					<input type="text" class="sm mt-2" disabled  bind:value={sombra3}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Spread</label>
					<input class="form-control" type="range" disabled id="sombraLogo3" step="0.01" max="500" bind:value={sombra4} />
				<input type="text" class="sm mt-2" disabled bind:value={sombra4}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" disabled type="color" id="corSombra"    bind:value={corSombra} />{corSombra}			
				</div>
		
			</div>
			{/if}
  {/if}
                
                
                
                </div>
        

  </div>

  